<template>
	<section class="detail-nested">
		<header>
			<i class="ion-android-arrow-back detail-header-icon" @click="closeView"></i>
			<h2>Migrations</h2>
		</header>
		<section class="migrations-section">
			<div v-if="!migrations || migrations.length === 0" class="empty">No migration data found.</div>
			<table v-else class="prompt-table">
				<thead>
					<tr>
						<th class="sortable" :aria-sort="ariaSort('item_type')">
							<button class="sort-trigger" @click="toggleSort('item_type')">Item Type <i :class="sortIcon('item_type')"></i></button>
						</th>
						<th class="sortable" :aria-sort="ariaSort('status')">
							<button class="sort-trigger" @click="toggleSort('status')">Status <i :class="sortIcon('status')"></i></button>
						</th>
						<th class="sortable" :aria-sort="ariaSort('source_count')">
							<button class="sort-trigger" @click="toggleSort('source_count')">Source <i :class="sortIcon('source_count')"></i></button>
						</th>
						<th class="sortable" :aria-sort="ariaSort('migrated_count')">
							<button class="sort-trigger" @click="toggleSort('migrated_count')">Migrated <i :class="sortIcon('migrated_count')"></i></button>
						</th>
						<th class="sortable" :aria-sort="ariaSort('culled_count')">
							<button class="sort-trigger" @click="toggleSort('culled_count')">Culled <i :class="sortIcon('culled_count')"></i></button>
						</th>
						<th class="sortable" :aria-sort="ariaSort('create_time')">
							<button class="sort-trigger" @click="toggleSort('create_time')">Created <i :class="sortIcon('create_time')"></i></button>
						</th>
						<th>Error</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="migration in sortedMigrations" :key="migration.id" class="prompt-row no-click">
						<td class="name-cell">{{ formatItemType(migration.item_type) }}</td>
						<td><span :class="['status-badge', statusClass(migration.status)]">{{ migration.status }}</span></td>
						<td>{{ migration.source_count }}</td>
						<td>{{ migration.migrated_count }}</td>
						<td>{{ migration.culled_count }}</td>
						<td class="date-cell">{{ formatDateTime(migration.create_time) }}</td>
						<td class="error-cell">{{ migration.error_message || '-' }}</td>
					</tr>
				</tbody>
			</table>
		</section>
	</section>
</template>


<script>
import util from '@/util'

export default {
	name: 'user-migrations',
	store: ['users'],
	data() {
		return {
			activeId: null,
			sortBy: 'create_time',
			sortDir: 'desc'
		}
	},

	computed: {
		user() {
			return this.users[this.activeId] || { name: null }
		},
		migrations() {
			return this.user.migrations || []
		},
		sortedMigrations() {
			return util.sortBy(this.migrations, this.sortBy, this.sortDir)
		}
	},

	created() {
		window.addEventListener('keyup', this.handleKeyup)
		this.activeId = this.$route.params.id
	},
	destroyed() {
		window.removeEventListener('keyup', this.handleKeyup)
	},

	watch: {
		'$route'() {
			this.activeId = this.$route.params.id
		}
	},

	methods: {
		closeView() {
			this.$emit('closeNested')
		},

		handleKeyup(e) {
			if (e.keyCode === 27 || e.key === 'Escape') this.closeView()
		},

		formatDateTime(date) {
			return util.formatDateTo(date, 'MMM D, YYYY HH:mm:ss')
		},

		formatItemType(type) {
			if (!type) return ''
			return type.charAt(0).toUpperCase() + type.slice(1)
		},

		statusClass(status) {
			if (status === 'succeeded') return 'succeeded'
			if (status === 'failed') return 'failed'
			return ''
		},

		toggleSort(field) {
			if (this.sortBy === field) {
				this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
			} else {
				this.sortBy = field
				this.sortDir = field === 'item_type' || field === 'status' ? 'asc' : 'desc'
			}
		},
		sortIcon(field) {
			if (this.sortBy !== field) return 'fa fa-sort sort-icon sort-icon--inactive'
			return this.sortDir === 'asc' ? 'fa fa-sort-asc sort-icon' : 'fa fa-sort-desc sort-icon'
		},
		ariaSort(field) {
			if (this.sortBy !== field) return 'none'
			return this.sortDir === 'asc' ? 'ascending' : 'descending'
		}
	}
}
</script>


<style src="../prompts/styles/prompt-common.css"></style>
<style scoped>
.migrations-section {
	margin-bottom: 2em;
}

.prompt-table thead th {
	opacity: 1;
	padding: 12px 16px;
}

.prompt-table .sort-trigger {
	width: auto;
	background: none;
	color: inherit;
	padding: 0;
	border-radius: 0;
}

.no-click {
	cursor: default;
}

.name-cell {
	font-weight: 500;
	color: #0f172a;
}

.error-cell {
	color: #94a3b8;
	font-size: 0.8rem;
}

.status-badge {
	display: inline-block;
	font-size: 0.7rem;
	padding: 3px 0;
	width: 80px;
	text-align: center;
	border-radius: 20px;
	text-transform: uppercase;
	font-weight: 600;
	letter-spacing: 0.03em;
}
.status-badge.succeeded { background: #d1fae5; color: #065f46; }
.status-badge.failed { background: #fee2e2; color: #991b1b; }
</style>
